var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mission-detail-map flex-fixed",style:({ height: _vm.height }),attrs:{"id":"MissionDetailMap"}},[_c('div',{ref:"container",staticClass:"mission-detail-map__canvas",style:({ height: _vm.height })})])}
var staticRenderFns = []

export { render, staticRenderFns }